import { render } from "./FbAddTableRow.vue?vue&type=template&id=a256b3f6"
import script from "./FbAddTableRow.vue?vue&type=script&lang=js"
export * from "./FbAddTableRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__